import { column, edge, flow, makeFlow, node } from "../builders";
import type { TemplateDef } from "../types";

const onboard = column("f1", 100, 70, 92, [
  ["t1", "auto-trigger", "Partner approved", { props: { triggerType: "Tag Added", tag: "partner", event: "partner" } }],
  ["e1", "auto-email", "Welcome — here's your link", { props: { subject: "Your referral link + how commission works" } }],
  ["w1", "auto-wait", "Wait 3 days", { props: { duration: "3", unit: "days" } }],
  ["e2", "auto-email", "3 ways partners get their first referral", { props: { subject: "What works for our top partners" } }],
  ["k1", "auto-task", "Intro call with the partner", { props: { assignee: "Partnerships", due: "+7 days" } }],
]);

const credit = column("f2", 100, 70, 92, [
  ["t2", "auto-trigger", "Referred purchase", { props: { triggerType: "Order Submitted", event: "Order with a partner code" } }],
  ["at", "auto-record-attribution", "Credit the partner", { props: { utmSource: "{{contact.partner_code}}", utmMedium: "referral", utmCampaign: "partner-program" } }],
  ["e3", "auto-email", "You earned a commission", { props: { subject: "Someone you sent just bought 🎉" } }],
  ["nt", "auto-notify", "Queue the payout", { props: { channel: "email", message: "Commission due to {{contact.partner_code}}" } }],
  ["tg", "auto-tag-add", "Tag: partner-active", { props: { tag: "partner-active" } }],
]);

const def: TemplateDef = {
  slug: "referral-partner-program",
  name: "Referral & Partner Program",
  category: "Lead gen",
  tagline:
    "Onboard partners, track who sent whom, and pay out without chasing a spreadsheet.",
  description:
    "A free referral program template: an approval tag onboards the partner with their link, and a second flow credits the referral on every purchase, notifies the payout, and keeps active partners tagged. Clone it into FrazzleCRM and the attribution is recorded on the contact.",
  whatsInside: [
    "Partner onboarding flow triggered by an approval tag",
    "A trigger link that forwards to your offer and fires the automation",
    "Purchase flow that records the referral as an attribution touch",
    "Payout notification plus a partner-active tag for reporting",
  ],
  flow: makeFlow(
    [
      node("ap", "page-optin", "Partner application", 40, 140, { props: { magnet: "Partner program" } }),
      flow("f1", "Partner Onboarding", 360, 40, 420, 580),
      ...onboard.nodes,
      node("tl", "auto-trigger-link", "The referral link", 880, 100, { props: { destination: "https://your-offer.com" } }),
      node("sp", "page-sales", "Your offer", 880, 280, { props: { price: "$497" } }),
      node("co", "page-checkout", "Checkout", 880, 460, { props: { price: "$497" } }),
      flow("f2", "Referral Credited", 1200, 40, 420, 580),
      ...credit.nodes,
      node("out", "outcome-sale", "Referred sale", 1720, 260, { props: { value: "$497" } }),
      node("n1", "util-note", "Store the code on the contact", 40, 380, {
        notes:
          "Put the partner code on a contact field at opt-in, then every later step can read {{contact.partner_code}} — no join table, no monthly reconciliation.",
      }),
    ],
    [
      edge("ap", "f1"),
      ...onboard.edges,
      edge("f1", "tl"),
      edge("tl", "sp"),
      edge("sp", "co"),
      edge("co", "f2"),
      ...credit.edges,
      edge("f2", "out"),
    ]
  ),
};

export default def;
